import styled from 'styled-components';
import { makeContainerMaxWidth, makeContainer, makeMainContainer, makeRow, makeCol } from './mixins';
/**
 * Container widths
 * Set the container width, and override it for fixed navbars in media queries.
 */
export const MainContainer = styled.div `
  ${props => makeMainContainer(props)}
  ${makeContainerMaxWidth}
`;
/**
 * Container widths
 * Set the container width, and override it for fixed navbars in media queries.
 */
export const Container = styled.div `
  ${props => makeContainer(props)}
  ${makeContainerMaxWidth}
`;
/**
 * Fluid container
 * Utilizes the mixin meant for fixed width containers, but with 100% width for
 * fluid, full width layouts.
 */
export const ContainerFluid = styled.div `
  ${props => makeContainer(props)}
`;
/**
 * Row
 * Rows contain and clear the floats of your columns.
 */
export const Row = styled.div `
  ${props => makeRow(props)}
`;
export const Col = styled.div `
  ${props => makeCol(props)}
`;
